export default __webpack_public_path__ + "media/images/images/raty/cancel-on-179868c3be5cd2e8b8fdf7717ca75689.png";